import { Cancel, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
} from "@mui/material";
import { auth } from "configs/firebaseConfigs";
import { useAppContext } from "contexts";
import {
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from "firebase/auth";
import { useFormik } from "formik";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as Yup from "yup";

const PasswordChange = (props) => {
  const [loading, setLoading] = useState(false);
  const { user } = useAppContext();
  const [typePassword, setTypePassword] = useState({
    oldPassword: true,
    newPassword: true,
    confirmPassword: true,
  });

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      email: user?.email,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      oldPassword: Yup.string("Invalid Password").required("Required"),
      newPassword: Yup.string("Invalid Password")
        .required("Required")
        .min(6, "Password must be at least 6 characters"),
      confirmPassword: Yup.string("Invalid Password").oneOf(
        [Yup.ref("newPassword"), null],
        "Passwords must match"
      ),
      email: Yup.string("Invalid Email")
        .required("Required")
        .email("Invalid Email"),
    }),
    onSubmit: async (values, submitProps) => {
      try {
        setLoading(true);
        signInWithEmailAndPassword(auth, values?.email, values?.oldPassword)
          .then(async () => {
            await updatePassword(auth.currentUser, values?.newPassword);
            Swal.fire({
              title: "Success",
              text: "Password has been changed",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              setLoading(false);
              props.changeState(false);
              signOut(auth, () => {
                navigate("/login?redirect=/");
              });
            });
          })
          .catch((err) => {
            // console.log(err);
            setLoading(false);
            Swal.fire({
              title: "Error",
              text: "Invalid Password",
              icon: "error",
            });
            return;
          });

        submitProps.resetForm();
      } catch (error) {
        // console.log(error);
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: "Please try again later",
        });
        signOut(auth);
      }
    },
  });

  return (
    <section className="change-password-section">
      <div className="change-password-box flex-column">
        <div className="change-password-title flex-row align-items-center justify-content-between ">
          <p>Change your password</p>
          <span
            onClick={() => {
              props.changeState(false);
            }}
          >
            <Cancel />
          </span>
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className="change-password-main-container flex-column gap-2 "
        >
          {user?.uid && (
            <span className="flex-row align-items-center gap-2">
              Email : {user?.email}
            </span>
          )}
          {!user?.email && (
            <span className=" change-password-input flex-row align-items-center gap-2">
              <InputLabel> Email </InputLabel>

              <TextField
                placeholder="Enter your Email"
                type="email"
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.errors.email && formik.touched.email ? true : false
                }
                helperText={
                  formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : ""
                }
              />
            </span>
          )}

          <span className=" change-password-input flex-row align-items-center gap-2">
            <InputLabel> Old Password </InputLabel>

            <TextField
              placeholder="Enter old password"
              type={typePassword?.oldPassword ? "password" : "text"}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name="oldPassword"
              error={
                formik.errors.oldPassword && formik.touched.oldPassword
                  ? true
                  : false
              }
              helperText={
                formik.errors.oldPassword && formik.touched.oldPassword
                  ? formik.errors.oldPassword
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setTypePassword((prev) => {
                          return {
                            ...prev,
                            oldPassword: !prev.oldPassword,
                          };
                        });
                      }}
                      // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {typePassword?.oldPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </span>

          <span className=" change-password-input flex-row align-items-center gap-2">
            <InputLabel> New Password </InputLabel>

            <TextField
              placeholder="Enter new password"
              type={typePassword?.newPassword ? "password" : "text"}
              name="newPassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.errors.newPassword && formik.touched.newPassword
                  ? true
                  : false
              }
              helperText={
                formik.errors.newPassword && formik.touched.newPassword
                  ? formik.errors.newPassword
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setTypePassword((prev) => {
                          return {
                            ...prev,
                            newPassword: !prev.newPassword,
                          };
                        });
                      }}
                      // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {typePassword?.newPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </span>
          <span className=" change-password-input flex-row align-items-center gap-2">
            <InputLabel> Confirm Password </InputLabel>

            <TextField
              placeholder="Enter new password"
              type={typePassword?.confirmPassword ? "password" : "text"}
              name="confirmPassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.errors.confirmPassword && formik.touched.confirmPassword
                  ? true
                  : false
              }
              helperText={
                formik.errors.confirmPassword && formik.touched.confirmPassword
                  ? formik.errors.confirmPassword
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setTypePassword((prev) => {
                          return {
                            ...prev,
                            confirmPassword: !prev.confirmPassword,
                          };
                        });
                      }}
                      // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {typePassword?.confirmPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </span>
          <div className="change-password-btn flex-row align-items-center justify-content-center">
            <Button type="submit">
              {" "}
              {loading ? (
                <CircularProgress size={20} />
              ) : (
                "Change Password"
              )}{" "}
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default PasswordChange;
